// Načtení pdfjs pro náhledy PDF (doklady, směrnice, školení).
//
// Worker se bere **z našeho buildu**, ne z CDN. Tři místa v aplikaci si dřív
// každé samo nastavovalo `workerSrc` na cdn.jsdelivr.net — takže náhled PDF
// fungoval jen se živým internetem a jen tam, kde CDN neblokuje síť. OS je
// přitom PWA, která běží na tabletech v provozu; „náhled se nepodařilo načíst"
// bez jediné vlastní chyby je špatná odpověď. Vite si soubor workeru odnese do
// `public/build` a dá nám na něj hashovanou URL, takže se veze se zbytkem
// aplikace (a service worker si ho může nacachovat).
//
// Import se drží `?url`: worker NESMÍ projít bundlerem jako modul, potřebujeme
// jen adresu souboru.
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

let pdfjs = null;

/**
 * Vrátí připravenou knihovnu pdfjs (jeden import na celou session — 400 kB
 * chunk se nestahuje, dokud první náhled opravdu nepotřebuje).
 */
export async function nactiPdfjs() {
    if (!pdfjs) {
        const lib = await import('pdfjs-dist');
        lib.GlobalWorkerOptions.workerSrc = workerUrl;
        pdfjs = lib;
    }
    return pdfjs;
}
